import { render, staticRenderFns } from "./imgPopover.vue?vue&type=template&id=47d48bd9&scoped=true&"
import script from "./imgPopover.vue?vue&type=script&lang=js&"
export * from "./imgPopover.vue?vue&type=script&lang=js&"
import style0 from "./imgPopover.vue?vue&type=style&index=0&id=47d48bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d48bd9",
  null
  
)

export default component.exports